'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _class, _temp2;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _CheckBox = require('./CheckBox');
var _CheckBox2 = _interopRequireDefault(_CheckBox);
var _inputsStyles = require('../inputsStyles/inputsStyles');
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.columns');
var _wavfichacertaFichacertaSharedStyles2 = require('@bit/wavfichacerta.fichacerta.shared-styles.rows');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Group = (_temp2 = _class = function (_PureComponent) {
  _inherits(Group, _PureComponent);
  function Group() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Group);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Group.__proto__ || Object.getPrototypeOf(Group)).call.apply(_ref, [this].concat(args))), _this), _this.onCheck = function (option) {
      return function (e) {
        var _this$props = _this.props,
          input = _this$props.input,
          onCheck = _this$props.onCheck;
        var newValues = [].concat(_toConsumableArray(input.value));
        var checked = e.target.checked;
        if (checked) {
          newValues.push(option.value);
        } else {
          newValues = newValues.filter(function (value) {
            return value !== option.value;
          });
        }
        onCheck(checked, option);
        input.onChange(newValues);
      };
    }, _this.getBoxColor = function () {
      var _this$props2 = _this.props,
        input = _this$props2.input,
        required = _this$props2.required;
      if (required) {
        if (Array.isArray(input.value) && input.value.length > 0) {
          return 'color_green';
        }
        return 'color_orange';
      }
      return 'checkbox_color';
    }, _this.handleOptionsList = function () {
      var input = _this.props.input;
      var mappedOption = _this.props.options.map(function (option) {
        return _react2.default.createElement(_CheckBox2.default, {
          boxColor: _this.getBoxColor(),
          key: option.value,
          disabled: _this.props.disabled,
          name: input.name + '_' + option.value,
          checked: input.value.indexOf(option.value) !== -1,
          label: option.label,
          onChange: _this.onCheck(option)
        });
      });
      return mappedOption;
    }, _this.handleOptionsDirectionRender = function () {
      if (_this.props.direction === 'column') {
        return _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.BaseColumn, null, _this.handleOptionsList());
      }
      return _react2.default.createElement(_wavfichacertaFichacertaSharedStyles2.StyledRow, {
        justify: 'flex-start'
      }, _this.handleOptionsList());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Group, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.BaseColumn, {
        margin: this.props.margin || '24px 0 0 0',
        padding: this.props.padding || '0 0 0 10px',
        customstyle: this.props.containerStyle,
        'data-testid': 'CheckBoxGroup',
        className: this.props.size
      }, _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.BaseColumn, {
        margin: '0 0 5px 0',
        customstyle: this.props.labelContainerStyle
      }, _react2.default.createElement(_inputsStyles.CheckBoxGroupLabelContainer, null, _react2.default.createElement(_inputsStyles.StyledLabel, null, this.props.title || 'Serviços de Interesse (no mínimo um)'), this.props.meta.dirty && this.props.input.value.length === 0 && _react2.default.createElement(_inputsStyles.StyledErrorSpanForCheckboxGroup, null, 'Escolha pelo menos uma op\xE7\xE3o'))), this.handleOptionsDirectionRender());
    }
  }]);
  return Group;
}(_react.PureComponent), _class.defaultProps = {
  onCheck: function onCheck() {
    return undefined;
  },
  containerStyle: {},
  labelContainerStyle: {}
}, _temp2);
exports.default = Group;